var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var LETTER_REGEX = /[A-Za-zÀ-ÖØ-öø-ÿ]/;
var LOWERCASE_REGEX = /[a-zà-öø-ÿ]/;
var UPPERCASE_REGEX = /[A-ZÀ-ÖØ-Þ]/;
var UPPERCASE_VOWEL_REGEX = /[AEIOUÁÉÍÓÚÂÊÔÃÕÀÜ]/g;
var TOKEN_REGEX = /[A-Za-zÀ-ÖØ-öø-ÿ0-9+&]+|[^A-Za-zÀ-ÖØ-öø-ÿ0-9+&]+/g;
var hasLetters = function (value) { return LETTER_REGEX.test(value); };
var isUppercaseText = function (value) {
    var lettersOnly = value.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ]/g, "");
    return (lettersOnly.length > 0 &&
        !LOWERCASE_REGEX.test(lettersOnly) &&
        UPPERCASE_REGEX.test(lettersOnly));
};
var isSingleTokenUppercaseLabel = function (value) {
    return value.split(/\s+/).filter(Boolean).length === 1 && isUppercaseText(value);
};
var shouldNormalizeUppercaseText = function (value) {
    if (!hasLetters(value) || !isUppercaseText(value))
        return false;
    if (isSingleTokenUppercaseLabel(value))
        return false;
    return true;
};
var preserveUppercaseToken = function (token) {
    var _a;
    if (!hasLetters(token) || !isUppercaseText(token))
        return false;
    var lettersOnly = token.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ]/g, "");
    if (/[0-9+&]/.test(token))
        return true;
    var vowelCount = ((_a = lettersOnly.match(UPPERCASE_VOWEL_REGEX)) !== null && _a !== void 0 ? _a : []).length;
    var consonantRatio = (lettersOnly.length - vowelCount) / lettersOnly.length;
    if (lettersOnly.length <= 4 && consonantRatio >= 0.75)
        return true;
    return false;
};
var toSentenceCase = function (value) {
    var _a;
    var shouldCapitalizeNextWord = true;
    return ((_a = value.match(TOKEN_REGEX)) !== null && _a !== void 0 ? _a : [value])
        .map(function (token) {
        if (!hasLetters(token)) {
            if (/[.!?]\s*$/.test(token)) {
                shouldCapitalizeNextWord = true;
            }
            else if (/[\/(\-]\s*$/.test(token)) {
                shouldCapitalizeNextWord = true;
            }
            return token;
        }
        if (preserveUppercaseToken(token)) {
            shouldCapitalizeNextWord = false;
            return token;
        }
        var normalizedToken = token.toLocaleLowerCase("pt-BR");
        if (!shouldCapitalizeNextWord) {
            return normalizedToken;
        }
        shouldCapitalizeNextWord = false;
        return normalizedToken.charAt(0).toLocaleUpperCase("pt-BR") + normalizedToken.slice(1);
    })
        .join("");
};
export var normalizeDisplayText = function (value) {
    var text = String(value !== null && value !== void 0 ? value : "")
        .replace(/\s+/g, " ")
        .trim();
    if (!text || !shouldNormalizeUppercaseText(text)) {
        return text;
    }
    return toSentenceCase(text);
};
export var normalizeChartDisplayData = function (data) {
    var _a;
    return (__assign(__assign({}, data), { dataset: ((_a = data.dataset) !== null && _a !== void 0 ? _a : []).map(function (item) {
            if (!item || typeof item !== "object")
                return item;
            return Object.fromEntries(Object.entries(item).map(function (_a) {
                var key = _a[0], value = _a[1];
                return [
                    key,
                    typeof value === "string" ? normalizeDisplayText(value) : value,
                ];
            }));
        }) }));
};
export var normalizeChartApiResponse = function (response) { return (__assign(__assign({}, response), { data: normalizeChartDisplayData(response.data) })); };
export var normalizeDashboardKpiItem = function (item) { return (__assign(__assign({}, item), { label: normalizeDisplayText(item.label), detail_suffix: item.detail_suffix
        ? normalizeDisplayText(item.detail_suffix)
        : item.detail_suffix, error: item.error ? normalizeDisplayText(item.error) : item.error, value: item.value ? normalizeDisplayText(item.value) : item.value, detail: item.detail ? normalizeDisplayText(item.detail) : item.detail, payload: item.payload ? normalizeChartDisplayData(item.payload) : item.payload })); };
export var normalizeDashboardKpiItems = function (items) { return items.map(normalizeDashboardKpiItem); };
export var normalizeDashboardFilterOptionsResponse = function (response) { return (__assign(__assign({}, response), { items: response.items.map(function (item) { return (__assign(__assign({}, item), { label: normalizeDisplayText(item.label), options: item.options.map(function (option) { return (__assign(__assign({}, option), { label: normalizeDisplayText(option.label) })); }) })); }) })); };
export var normalizeDashboardCatalogResponse = function (response) { return (__assign(__assign({}, response), { domains: response.domains.map(function (domain) { return (__assign(__assign({}, domain), { label: normalizeDisplayText(domain.label), sections: domain.sections.map(function (section) { return (__assign(__assign({}, section), { label: normalizeDisplayText(section.label), charts: section.charts.map(function (chart) { return (__assign(__assign({}, chart), { title: normalizeDisplayText(chart.title), subtitle: chart.subtitle
                    ? normalizeDisplayText(chart.subtitle)
                    : chart.subtitle })); }) })); }) })); }) })); };
